import { render } from "./AppFooter.vue?vue&type=template&id=5b6b1f2a"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=5b6b1f2a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__